"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCalcSpire = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const ltentity_1 = require("../../cadplugins/cad/ltentity");
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const segment_1 = require("../../cadplugins/cad/segment");
const sprinklerutils_1 = require("../sprinkler/sprinklerutils");
const pipeNode_1 = require("../pipe/pipeNode");
const commandfactory_1 = require("../../cadplugins/map/commandfactory");
const ltutils_1 = require("../../cadplugins/cad/ltutils");
const config_1 = require("../rule/config");
class SpireNode extends pipeNode_1.PipeNode {
    constructor(map, point, type) {
        super(new Coordinate_js_1.default(point.x, point.y), type);
        this._index = "";
        //起点压力
        this.start_pressure = 0;
        //终点压力;
        this.end_pressure = 0;
        //管径(mm)
        this._pipe_diameter = 0;
        this._k = 80;
        //节点流量;
        this._spary_flow = 0;
        //管段流量
        this._segment_flow = 0;
        //从子节点到父节点流向为false;
        this.isPositive = false;
        //对于主管,可以虚拟化一个喷淋头来
        this._is_virual_sprie = false;
        this._map = map;
        this._pipe_dimater_map = new Map([['DN25', 0.0273], ['DN32', 0.0354], ['DN40', 0.0413], ['DN50', 0.0527],
            ['DN65', 0.0681], ['DN80', 0.0809], ['DN100', 0.1063], ['DN150', 0.1561], ['DN200', 0.2071], ['DN250', 0.261], ['DN300', 0.313]]);
    }
    get sparyFlow() {
        return this._spary_flow;
    }
    hasMainChild() {
        for (let sub_child of this._children) {
            if (sub_child._type == pipeNode_1.PipeNodeType.Main) {
                return true;
            }
            return false;
        }
    }
    set sparyFlow(n) {
        this._spary_flow = n;
    }
    get segmentFlow() {
        return this._segment_flow;
    }
    set segmentFlow(flow) {
        this._segment_flow = flow;
    }
    get virualSprie() {
        return this._is_virual_sprie;
    }
    set virualSprie(v) {
        this._is_virual_sprie = v;
    }
    //获取和父节点的距离;
    getDistance() {
        if (this._parent == null) {
            return 0;
        }
        let dis = Math.sqrt(Math.pow(this._parent._point.x - this._point.x, 2) + Math.pow(this._parent._point.y - this._point.y, 2));
        return dis * 0.001;
    }
    //获取两点间的管线;
    _getPipeByIndex(start_node, end_node) {
        //根据任意一个点查询;
        function sub_query(layer) {
            if (layer == null) {
                return null;
            }
            function query_pipe_callback(fea) {
                let geo = fea.getGeometry();
                if (!(geo instanceof ltentity_1.LTLine)) {
                    return false;
                }
                let start_point = geo.subData().getStartPoint();
                let end_point = geo.subData().getEndPoint();
                if (start_point.equals(start_node._point) &&
                    end_point.equals(end_node._point)) {
                    return true;
                }
                else if (start_point.equals(end_node._point) &&
                    end_point.equals(start_node._point)) {
                    return true;
                }
                return false;
            }
            let query_box = ltpoint_1.RBox.fromCenter(start_node._point, 10);
            let result_feature = layer.getFeature(query_box, query_pipe_callback);
            if (result_feature == null) {
                return null;
            }
            return result_feature;
        }
        let layer = this._map.getLayerByName(sprinklerutils_1.BRANCHPIPE_LAYER);
        if (layer !== null) {
            let result = sub_query(layer);
            if (result !== null) {
                return result;
            }
        }
        layer = this._map.getLayerByName(sprinklerutils_1.MAINPIPE_LAYER);
        if (layer !== null) {
            let result = sub_query(layer);
            if (result !== null) {
                return result;
            }
        }
        return null;
    }
    _getPipeDiamterByText() {
        let start_point = new ltpoint_1.LTPoint(this._point.x, this._point.y);
        if (this._parent == undefined) {
            return 0;
        }
        let end_point = new ltpoint_1.LTPoint(this._parent._point.x, this._parent._point.y);
        return SpireNode.getPipeDiamterByText(start_point, end_point, this._map);
    }
    static getPipeDiamterByText(start_point, end_point, map) {
        //获取标注图层;
        let annotation_layer = map.getLayerByName(sprinklerutils_1.PIPDIAMETER_ANNO_LAYER);
        if (annotation_layer == null) {
            return 0;
        }
        let equal_x = true;
        let minx = 0;
        let maxx = 0;
        if (Math.abs(end_point.x - start_point.x) < 10) {
            equal_x = false;
            minx = start_point.y;
            maxx = end_point.y;
            if (start_point.y > end_point.y) {
                minx = end_point.y;
                maxx = start_point.y;
            }
        }
        else {
            minx = start_point.x;
            maxx = end_point.x;
            if (start_point.x > end_point.x) {
                minx = end_point.x;
                maxx = start_point.x;
            }
        }
        function query_text_callback(fea) {
            let text_geo = fea.getGeometry();
            if (text_geo == null) {
                return false;
            }
            let text = text_geo.subData().text.substring(0, 2);
            if (text == null) {
                return false;
            }
            if (text.indexOf("DN") < 0) {
                return false;
            }
            let pos = text_geo.subData().position;
            if (pos == null) {
                return false;
            }
            if (equal_x == true) {
                if (minx < pos.x && maxx > pos.x) {
                    return true;
                }
            }
            else {
                if (minx < pos.y && maxx > pos.y) {
                    if (text_geo.subData().getRotate() > 0) {
                        return true;
                    }
                }
            }
            return false;
        }
        let c = ltpoint_1.LTPoint.getMinimun(start_point, end_point);
        let b = ltpoint_1.LTPoint.getMaximun(start_point, end_point);
        if (Math.abs(c.x - b.x) < 1e-5) {
            c.x = c.x - 300;
            b.x = b.x + 300;
        }
        if (Math.abs(c.y - b.y) < 1e-5) {
            c.y = c.y - 300;
            b.y = b.y + 300;
        }
        let query_box = ltpoint_1.RBox.formVectors(c, b);
        let result_feature = annotation_layer.getFeature(query_box, query_text_callback);
        if (result_feature == null) {
            return 0;
        }
        let text_geo = result_feature.getGeometry();
        if (text_geo == null) {
            return 0;
        }
        let text = text_geo.subData().text.replace("DN", "");
        if (text == null) {
            return 0;
        }
        let val = parseInt(text);
        return val * 0.001;
    }
    _getPipeDiameter2() {
        let start_point = new ltpoint_1.LTPoint(this._point.x, this._point.y);
        if (this.parent == undefined) {
            return 0;
        }
        let end_point = new ltpoint_1.LTPoint(this.parent._point.x, this.parent._point.y);
        let feature = this._getPipeByIndex(this, this.parent);
        if (feature != null && feature._xdata !== null && feature._xdata.pipeSize !== undefined) {
            let pipe_size = feature._xdata.pipeSize;
            let dn = pipe_size.replace("DN", "");
            return Number.parseInt(dn) * 0.001;
        }
        return this._getPipeDiamterByText();
    }
    _getPipeDiameter() {
        let start_point = new ltpoint_1.LTPoint(this._point.x, this._point.y);
        if (this.parent == undefined) {
            return 0;
        }
        let end_point = new ltpoint_1.LTPoint(this.parent._point.x, this.parent._point.y);
        let feature = this._getPipeByIndex(this, this.parent);
        if (feature != null && feature._xdata !== null && feature._xdata.pipeSize !== undefined) {
            let pipe_size = feature._xdata.pipeSize;
            if (this._pipe_dimater_map.has(pipe_size)) {
                let val = this._pipe_dimater_map.get(pipe_size);
                if (val == null) {
                    let dn = pipe_size.replace("DN", "");
                    return Number.parseInt(dn) * 0.001;
                }
                return val;
            }
            let dn = pipe_size.replace("DN", "");
            return Number.parseInt(dn) * 0.001;
        }
        return this._getPipeDiamterByText();
    }
    //水头损失;
    get headLoss() {
        //计算管道管段比阻A
        let pipe_diameter = this.pipeDiameter;
        let distance = this.getDistance();
        let A1 = (1.736 * Math.pow(10, -5)) / Math.pow(pipe_diameter - 0.001, 5.3);
        return (A1 * distance * Math.pow(this._segment_flow * 0.001, 2) * 1.05);
    }
    get pipeDiameter() {
        if (this._pipe_diameter !== 0) {
            return this._pipe_diameter;
        }
        this._pipe_diameter = this._getPipeDiameter();
        return this._pipe_diameter;
    }
    calcPipeDiameter() {
        this._pipe_diameter = this._getPipeDiameter();
    }
    get parent() {
        if (this._parent == undefined) {
            return undefined;
        }
        return this._parent;
    }
    get startPressure() {
        if (this.start_pressure !== 0) {
            return this.start_pressure;
        }
        if (this.isPositive) {
            return this.end_pressure - this.headLoss;
        }
        else {
            return this.end_pressure + this.headLoss;
        }
    }
    get endPressure() {
        if (this.end_pressure !== 0) {
            return this.end_pressure;
        }
        if (this.isPositive) {
            return this.start_pressure - this.headLoss;
        }
        return this.start_pressure + this.headLoss;
    }
    get rate() {
        return ((0.001 * 4 * this._segment_flow) /
            (Math.PI * this.pipeDiameter * this.pipeDiameter));
    }
    toJSON() {
        if (this.parent == undefined) {
            return {};
        }
        let test_name = `${this._index}-${this.parent._index}`;
        let start1 = this.startPressure.toFixed(3);
        let end1 = this.endPressure.toFixed(3);
        if (this.isPositive) {
            test_name = `${this.parent._index}-${this._index}`;
            start1 = this.endPressure.toFixed(3);
            end1 = this.startPressure.toFixed(3);
        }
        return {
            name: test_name,
            start_pressure: start1,
            pipe_length: this.getDistance().toFixed(3),
            pipe_diameter: this._getPipeDiameter2() * 1000,
            k: this._k.toString(),
            head_loss: this.headLoss.toFixed(3),
            segment_flow: this._segment_flow.toFixed(3),
            flow_rate: this.rate.toFixed(3),
            end_pressure: end1,
            spary_flow: this._spary_flow.toFixed(3),
        };
    }
}
class PipeSegmentTotal {
    constructor(root_node) {
        //作用面积
        this.area = 0;
        //最不利点压力
        this.min_pressure = 0;
        this.output_json = [];
        this._root_node = root_node;
    }
    get totalFlow() {
        if (this._root_node._children.length == 1) {
            return this._root_node._children[0].segmentFlow;
        }
        return 0;
    }
    toJSON() {
        return {
            pipe_segments: this.output_json,
            area: this.area.toFixed(3),
            total_flow: this.totalFlow.toFixed(3),
            min_pressure: this.min_pressure.toFixed(3),
            average_intensity: ((this.totalFlow * 60) / this.area).toFixed(3),
        };
    }
}
class NewSprink {
    constructor(map, polyline_area, k, strong, protected_area) {
        this._K = 80;
        this._strong_val = 0;
        this._protected_area = 160;
        this._min_pressure = 0.07;
        this._map = map;
        this._select_polyline_area = polyline_area;
        this._K = k;
        this._strong_val = strong;
        this._protected_area = protected_area;
        this._output_json = "";
    }
    //直接通过立管名字查找水流指示器;
    findFlowIndicatorWithAttribute(query_layer) {
        //查找水流指示器;
        function isFindBlock(block_feature) {
            let sub_geoemtry = block_feature.getGeometry();
            if (sub_geoemtry == null) {
                return false;
            }
            if (!(sub_geoemtry instanceof ltentity_1.LTEntityPoint)) {
                return false;
            }
            let block_name = sub_geoemtry.subData().blockName;
            if (block_name === null) {
                return false;
            }
            //查找水流指示器块名--流量计
            if (block_name !== sprinklerutils_1.WATERFLOW_NAME) {
                return false;
            }
            return true;
        }
        return query_layer.getFeatures(null, isFindBlock);
    }
    ConstructingTree() {
        //查找水流指示器;
        let layer = this._map.getLayerByName(sprinklerutils_1.WATERFLOW_LAYER);
        if (layer === null) {
            this._map.printMessage("找不到自喷设备图层");
            return false;
        }
        let is_test = true;
        let floor_node = null;
        if (!is_test) {
            let waterflow_blocks = this.findFlowIndicatorWithAttribute(layer);
            if (waterflow_blocks.length == 0) {
                return false;
            }
            let geo_point = waterflow_blocks[0].getGeometry();
            let waterfloor_point = this.findWaterFloorPoint(geo_point);
            if (waterfloor_point == null) {
                return false;
            }
            let root_node = this.buildTree(waterfloor_point);
            if (root_node == null) {
                return false;
            }
            //获取水流方向的起点;
            let flow_point = this.findMainPipeStartPoint();
            if (flow_point == null) {
                return false;
            }
            //获取当前的节点;
            floor_node = this.traverseSearchPoint(root_node, flow_point);
            if (floor_node == null) {
                return false;
            }
            floor_node._parent = undefined;
            //移除不在范围内的数据;
            for (let i = floor_node._children.length - 1; i >= 0; --i) {
                let child = floor_node._children[i];
                let sub_point = child._point;
                if (!ltutils_1.LTUtils.containsByPoint(this._select_polyline_area.subData().vertices, new ltpoint_1.LTPoint(sub_point.x, sub_point.y))) {
                    let remove_index = floor_node._children.indexOf(child);
                    floor_node._children.splice(remove_index, 1);
                }
            }
        }
        else {
            //从某个点开始构建;
            let flow_point = this.findMainPipeStartPoint();
            if (flow_point == null) {
                return false;
            }
            floor_node = this.buildTree(flow_point);
        }
        if (floor_node == null) {
            return false;
        }
        //最远处的节点可能是截止阀;
        let farthest_node_info = this.findFarthestNode(floor_node);
        let farthest_node = farthest_node_info[0];
        if (farthest_node == undefined || farthest_node._parent == undefined) {
            return false;
        }
        if (farthest_node._type == pipeNode_1.PipeNodeType.Valve) {
            let index = farthest_node._parent._children.indexOf(farthest_node);
            let parent = farthest_node.parent;
            if (parent) {
                parent.removeChildNode(farthest_node);
                farthest_node = parent;
            }
        }
        let text1 = "farthest";
        let geo_text1 = new ltentity_1.LTText(new ltpoint_1.LTPoint(farthest_node._point.x - 10, farthest_node._point.y + 20));
        geo_text1.text = text1;
        geo_text1.setColor("0x00ffff");
        geo_text1.setHeight(200);
        this.drawMap(geo_text1);
        let text2 = "floor";
        let geo_text2 = new ltentity_1.LTText(new ltpoint_1.LTPoint(floor_node._point.x, floor_node._point.y));
        geo_text2.text = text2;
        geo_text2.setHeight(200);
        this.drawMap(geo_text2);
        //建立编号;
        this.buildSprayNo2(farthest_node);
        //喷淋计算;
        return this.calc(floor_node, farthest_node);
    }
    //绘制到地图上;
    drawMap(geo) {
        if (this._map == null) {
            return;
        }
        let cad_canvas = this._map.canvas; // new TsPixiRenderCanvas(canvas);
        if (geo instanceof ltentity_1.LTEntity) {
            geo._graphicsData = [];
            geo.worldDraw(cad_canvas, true, null, this._map.trackGraphics);
        }
        else {
            geo.forEach((sub_geo) => {
                sub_geo._graphicsData = [];
                sub_geo.worldDraw(cad_canvas, true, null, this._map.trackGraphics);
            });
        }
    }
    //计算基础的符号值;
    calcSymbol(farthest_point_node) {
        //常值;
        let k = (this._K * Math.sqrt(10)) / 60000;
        let a_list = [];
        let sum_alpha = 1.0 / Math.pow(k, 2);
        //直接获取支管的节点列表;
        let current_node = farthest_point_node;
        while (current_node.parent !== undefined && current_node.parent._type !== pipeNode_1.PipeNodeType.Main) {
            let parent_node = current_node.parent;
            if (parent_node == undefined) {
                break;
            }
            //获取管径;
            let pipe_diameter2 = current_node.pipeDiameter;
            //获取管径距离;
            let A2 = (1.736 * Math.pow(10, -5)) / Math.pow(pipe_diameter2 - 0.001, 5.3);
            let distance2 = current_node.getDistance();
            if (a_list.length == 0) {
                let a = Math.sqrt(1 + A2 * distance2 * k * k);
                a_list.push(a);
                sum_alpha += A2 * distance2;
                current_node = parent_node;
                continue;
            }
            let a_sum = 0;
            for (let a_index = 0; a_index < a_list.length; ++a_index) {
                a_sum += a_list[a_index];
            }
            let last_a = a_list[a_list.length - 1];
            let temp_a = last_a *
                Math.sqrt(1 + A2 * distance2 * k * k * Math.pow((1 + a_sum) / last_a, 2));
            a_list.push(temp_a);
            sum_alpha += A2 * distance2 * Math.pow(1 + a_sum, 2);
            current_node = parent_node;
        }
        let a_sum = 0;
        for (let a_index = 0; a_index < a_list.length; ++a_index) {
            a_sum += a_list[a_index];
        }
        while (current_node._children.length == 1) {
            let distance = current_node.getDistance();
            let pipe_diameter = current_node.pipeDiameter;
            let A2 = (1.736 * Math.pow(10, -5)) / Math.pow(pipe_diameter - 0.001, 5.3);
            sum_alpha += A2 * distance * Math.pow(1 + a_sum, 2);
            let temp_current_node = current_node.parent;
            if (temp_current_node == undefined) {
                break;
            }
            current_node = temp_current_node;
        }
        return [sum_alpha, a_list];
    }
    //从远到近数组数据;
    calcSymbol2(spire_list) {
        //常值;
        let k = (this._K * Math.sqrt(10)) / 60000;
        let a_list = [];
        let sum_alpha = 1.0 / Math.pow(k, 2);
        for (let sub_spire of spire_list) {
            //获取管径;
            let pipe_diameter2 = sub_spire.pipeDiameter;
            //获取管径距离;
            let A2 = (1.736 * Math.pow(10, -5)) / Math.pow(pipe_diameter2 - 0.001, 5.3);
            let distance2 = sub_spire.getDistance();
            if (a_list.length == 0) {
                let a = Math.sqrt(1 + A2 * distance2 * k * k);
                a_list.push(a);
                sum_alpha += A2 * distance2;
                continue;
            }
            let a_sum = 0;
            for (let a_index = 0; a_index < a_list.length; ++a_index) {
                a_sum += a_list[a_index];
            }
            let last_a = a_list[a_list.length - 1];
            if (sub_spire._type == pipeNode_1.PipeNodeType.Child || sub_spire.virualSprie) {
                let temp_a = last_a *
                    Math.sqrt(1 + A2 * distance2 * k * k * Math.pow((1 + a_sum) / last_a, 2));
                a_list.push(temp_a);
            }
            sum_alpha += A2 * distance2 * Math.pow(1 + a_sum, 2);
        }
        return [sum_alpha, a_list];
    }
    buildSprayNo2(farthest_node) {
        //从当前节点找到main的父节点;
        let index = 1;
        let main_index = 1;
        const drawNode = (draw_node) => {
            let text2 = draw_node._index;
            let geo_text2 = new ltentity_1.LTText(new ltpoint_1.LTPoint(draw_node._point.x, draw_node._point.y));
            geo_text2.text = text2;
            geo_text2.setHeight(200);
            this.drawMap(geo_text2);
        };
        const build = (node) => {
            if (node._parent == undefined) {
                return;
            }
            //求主管节点;
            let main_node = undefined;
            if (node._type == pipeNode_1.PipeNodeType.Child) {
                while (node._parent != undefined &&
                    node._parent._type != pipeNode_1.PipeNodeType.Main) {
                    if (node.parent == undefined) {
                        break;
                    }
                    node = node.parent;
                }
                if (node.parent == undefined) {
                    return;
                }
                main_node = node.parent;
            }
            else {
                //理论上也是主管;
                main_node = node.parent;
            }
            if (main_node == undefined) {
                return;
            }
            //通过分支管排序;
            let spire_childs = [];
            let spire_mians = [];
            for (let child of main_node._children) {
                let sub_child = child;
                if (sub_child._index.length !== 0) {
                    continue;
                }
                if (sub_child._type == pipeNode_1.PipeNodeType.Child) {
                    spire_childs.push(child);
                }
                else {
                    spire_mians.push(child);
                }
            }
            //距离从大到小排序;
            spire_childs.sort((a, b) => {
                let dist1 = this.findFarthestNode(a)[1];
                let dist2 = this.findFarthestNode(b)[1];
                return dist2 - dist1;
            });
            for (let sub_child of spire_childs) {
                let child_node = this.findFarthestNode(sub_child)[0];
                while (child_node.parent !== main_node) {
                    child_node._index = index.toString();
                    drawNode(child_node);
                    ++index;
                    if (child_node.parent == undefined) {
                        break;
                    }
                    child_node = child_node.parent;
                }
                if (child_node._parent == main_node) {
                    child_node._index = index.toString();
                    drawNode(child_node);
                    ++index;
                }
            }
            //处理主管道
            for (let sub_main of spire_mians) {
                if (sub_main._index.length == 0) {
                    let farthest_node1 = this.findFarthestNode(sub_main)[0];
                    build(farthest_node1);
                }
            }
            //计算父节点的编号;
            if (main_node._index.length == 0) {
                main_node._index = "a" + main_index.toString();
                ++main_index;
                drawNode(main_node);
            }
            build(main_node);
        };
        build(farthest_node);
    }
    //计算保护面积;
    calcProtectArea(farthest_node) {
        if (farthest_node._parent == undefined) {
            return 0;
        }
        let x_distnace = 0;
        if (farthest_node._parent._type == pipeNode_1.PipeNodeType.Main) {
            //计算两个子的距离;
            let childs = farthest_node._parent._children.filter((child) => child._type == pipeNode_1.PipeNodeType.Child);
            if (childs.length == 2) {
                x_distnace = new ltpoint_1.LTPoint(childs[0]._point.x, childs[0]._point.y).getDistanceTo(new ltpoint_1.LTPoint(childs[1]._point.x, childs[1]._point.y));
                x_distnace = x_distnace * 0.001;
            }
        }
        else {
            x_distnace = farthest_node.getDistance();
        }
        let temp_node = farthest_node;
        //找到主节点;
        while (temp_node.parent !== undefined &&
            temp_node.parent._type !== pipeNode_1.PipeNodeType.Main) {
            temp_node = temp_node.parent;
        }
        let main_node = temp_node.parent;
        if (main_node == undefined) {
            return 0;
        }
        let y_distance = main_node.getDistance();
        return x_distnace * y_distance;
    }
    findFarthestNode(root) {
        let farthestNode = root;
        let maxDistance = 0;
        function dfs(node, distance) {
            if (distance > maxDistance) {
                farthestNode = node;
                maxDistance = distance;
            }
            for (const child of node._children) {
                //计算当前节点到父节点的距离;
                let sub_child = child;
                dfs(sub_child, distance + sub_child.getDistance());
            }
        }
        dfs(root, 0);
        return [farthestNode, maxDistance];
    }
    hasCommonBranch(root_node) {
        let childrens = root_node._children;
        if (childrens.length !== 2) {
            return false;
        }
        let node1 = childrens[0];
        let node2 = childrens[1];
        function calcNode(node) {
            let distances = [];
            while (node) {
                let distance = node.getDistance();
                distances.push(distance);
                if (node._children.length == 2) {
                    return distances;
                }
                else if (node._children.length == 1) {
                    node = node._children[0];
                }
                else {
                    break;
                }
            }
            return distances;
        }
        let distance1 = calcNode(node1);
        let distance2 = calcNode(node2);
        if (distance1.length !== distance2.length) {
            return false;
        }
        for (let i = 0; i < distance1.length; ++i) {
            if (Math.abs(distance1[i] - distance2[i]) > 1e-2) {
                return false;
            }
        }
        return true;
    }
    calc(flow_node, farthest_node) {
        //获取喷头数量;
        let spray_count = 0;
        function calcSpireCount(node) {
            if (node._type == pipeNode_1.PipeNodeType.Child) {
                spray_count++;
            }
            for (let child of node._children) {
                calcSpireCount(child);
            }
        }
        calcSpireCount(flow_node);
        //确定作用面积是否符合要求;
        let protect_area = this.calcProtectArea(farthest_node);
        let spray_area = spray_count * protect_area;
        let temp_area = this._select_polyline_area.subData().getArea();
        if (temp_area < this._protected_area) {
            this._map.printMessage(`小于作用面积，当前面积为:${spray_area} 规定为:${this._protected_area} 共有:${spray_count}个喷头`);
            return false;
        }
        let seg_total = new PipeSegmentTotal(flow_node);
        seg_total.area = temp_area / (1000 * 1000);
        //最不利的支管为farthest_point_index所在的支管;
        //喷头流量=喷头强度8*保护面积;
        let spray_flow = this._strong_val * protect_area;
        //工作压力 单位MPa 0.1*（喷头流量/特性系数）^2; 这里面特性系数为80;
        //起点压力，基本是固定的,有最小值限制;
        let farthest_pressure = 0.1 * Math.pow(spray_flow / this._K, 2);
        if (farthest_pressure < this._min_pressure) {
            farthest_pressure = this._min_pressure;
        }
        seg_total.min_pressure = farthest_pressure;
        if (farthest_node.pipeDiameter == 0) {
            return false;
        }
        //常值;
        let k = (this._K * Math.sqrt(10)) / 60000;
        //管道流量;
        let pipe_segment_flow = spray_flow / 60;
        let seg_startno = farthest_node._index;
        if (farthest_node.parent == null) {
            return false;
        }
        let seg_endno = farthest_node.parent._index;
        farthest_node.start_pressure = farthest_pressure;
        farthest_node.isPositive = false;
        farthest_node.sparyFlow = pipe_segment_flow;
        farthest_node.segmentFlow = pipe_segment_flow;
        let end_pressure = farthest_node.endPressure;
        let output_json = [];
        function pushNodeJson(json_node) {
            let index = output_json.findIndex(elem => elem == json_node);
            if (index !== -1) {
                output_json[index] = json_node;
            }
            else {
                output_json.push(json_node);
            }
        }
        console.log(JSON.stringify(farthest_node));
        pushNodeJson(farthest_node);
        let current_node = farthest_node.parent;
        //最不利支管计算完成;
        let main_node = null;
        while (current_node && current_node._type !== pipeNode_1.PipeNodeType.Main) {
            let sub_start_pressure = end_pressure;
            current_node.start_pressure = sub_start_pressure;
            current_node.calcPipeDiameter();
            //节点流量;
            current_node.sparyFlow = k * Math.sqrt(sub_start_pressure) * 1000;
            //管段流量=前一段的管段流量+节点流量;
            let sub_pipe_flow = current_node.sparyFlow + pipe_segment_flow;
            current_node.segmentFlow = sub_pipe_flow;
            end_pressure = current_node.endPressure;
            pipe_segment_flow = sub_pipe_flow;
            pushNodeJson(current_node);
            if (current_node.parent == undefined) {
                return false;
            }
            current_node = current_node.parent;
        }
        //计算到了主管道;
        if (current_node && current_node._type == pipeNode_1.PipeNodeType.Main) {
            //计算到主节点;
            main_node = current_node;
            main_node.start_pressure = end_pressure;
            main_node.calcPipeDiameter();
            main_node.sparyFlow = k * Math.sqrt(main_node.start_pressure) * 1000;
        }
        if (main_node == null) {
            return false;
        }
        //判断相对比例点是否与最不利点是否完全对称,如果完全对称。直接参照最不利点的计算方法;
        if (this.hasCommonBranch(main_node)) {
            let fastest_node = main_node._children[0];
            let other_node = main_node._children[1];
            if (fastest_node.sparyFlow == 0) {
                let temp_node = fastest_node;
                fastest_node = other_node;
                other_node = temp_node;
            }
            while (other_node) {
                other_node.start_pressure = farthest_node.startPressure;
                current_node.calcPipeDiameter();
                other_node.segmentFlow = farthest_node.segmentFlow;
                other_node.sparyFlow = farthest_node.sparyFlow;
                pushNodeJson(other_node);
                if (farthest_node._children.length == 0) {
                    break;
                }
                farthest_node = farthest_node._children[0];
                other_node = other_node._children[0];
                console.log(JSON.stringify(other_node));
            }
        }
        //递归
        const calcrecursion = (spire_main_node, pressure = null) => {
            //计算其他支管;
            let sub_pressure = pressure;
            if (sub_pressure == null) {
                sub_pressure = spire_main_node.startPressure;
            }
            let tol = 0.01;
            for (let child of spire_main_node._children) {
                let sub_child = child;
                if (sub_child._type == pipeNode_1.PipeNodeType.Main) {
                    //由主管道计算，因为主管道的压力已知，计算子管道的压力;
                    if (sub_child.sparyFlow !== 0) {
                        continue;
                    }
                    if (sub_child.hasMainChild() && sub_child._children.length > 1) {
                        let main_sub_child = sub_child;
                        //将这条线虚拟出一个普通的支管来计算,获取这条线的支线喷淋列表;
                        let is_common_x = false;
                        if (Math.abs(spire_main_node._point.x - sub_child._point.x) < tol) {
                            is_common_x = true;
                        }
                        let spire_node_list = [];
                        spire_node_list.push(main_sub_child);
                        while (sub_child._children.length > 0) {
                            //查找下一个符合条件的节点;
                            let next_child = null;
                            for (let temp_child of sub_child._children) {
                                if (temp_child._type !== pipeNode_1.PipeNodeType.Main) {
                                    continue;
                                }
                                if (is_common_x) {
                                    if (Math.abs(main_sub_child._point.x - temp_child._point.x) < tol) {
                                        spire_node_list.push(temp_child);
                                        temp_child.virualSprie = true;
                                        next_child = temp_child;
                                        break;
                                    }
                                }
                                else if (Math.abs(main_sub_child._point.y - temp_child._point.y) < tol) {
                                    spire_node_list.push(temp_child);
                                    temp_child.virualSprie = true;
                                    next_child = temp_child;
                                    break;
                                }
                            }
                            if (next_child == null) {
                                break;
                            }
                            sub_child = next_child;
                        }
                        spire_node_list.reverse();
                        let [sum_alpha, a_list] = this.calcSymbol2(spire_node_list);
                        //从大流量开始算起.
                        for (let i = 0; i < spire_node_list.length; ++i) {
                            let sub_spire = spire_node_list[i];
                            if (i == 0) {
                                let last_spray_flow = Math.sqrt(sub_pressure / sum_alpha) * 1000;
                                sub_spire.sparyFlow = last_spray_flow;
                                sub_spire.segmentFlow = last_spray_flow;
                                sub_spire.calcPipeDiameter();
                            }
                            else {
                                let index = i - 1;
                                if (i > spire_node_list.length - 1) {
                                    index = spire_node_list.length - 1;
                                }
                                sub_spire.sparyFlow = spire_main_node.start_pressure * a_list[index];
                                sub_spire.segmentFlow = sub_spire.sparyFlow + spire_node_list[i - 1].segmentFlow;
                            }
                        }
                        //计算压力;
                        for (let i = spire_node_list.length - 1; i >= 0; --i) {
                            let sub_spire = spire_node_list[i];
                            if (i == spire_node_list.length - 1) {
                                sub_spire.end_pressure = spire_main_node.startPressure;
                            }
                            sub_spire.isPositive = true;
                            if (i !== 0) {
                                let next_spire = spire_node_list[i - 1];
                                next_spire.end_pressure = sub_spire.startPressure;
                            }
                            console.log(JSON.stringify(sub_spire));
                            pushNodeJson(sub_spire);
                        }
                        for (let i = 0; i < spire_node_list.length; ++i) {
                            let sub_spire = spire_node_list[i];
                            //对于每个节点，浏览是固定的。
                            calcrecursion(sub_spire);
                        }
                    }
                    else {
                        if (spire_main_node.start_pressure !== 0) {
                            sub_child.end_pressure = spire_main_node.start_pressure;
                        }
                        calcrecursion(sub_child, spire_main_node.start_pressure);
                    }
                }
                else {
                    if (sub_child.endPressure != 0) {
                        continue;
                    }
                    //计算最远的支管的A值;
                    let sub_farthest_node = this.findFarthestNode(child)[0];
                    let [sum_alpha, a_list] = this.calcSymbol(sub_farthest_node);
                    //计算压力值;
                    let last_spray_flow = Math.sqrt(sub_pressure / sum_alpha) * 1000;
                    sub_farthest_node.sparyFlow = last_spray_flow;
                    sub_farthest_node.segmentFlow = last_spray_flow;
                    sub_farthest_node.calcPipeDiameter();
                    //计算剩下的数据;
                    let current_node = sub_farthest_node.parent;
                    if (current_node == undefined) {
                        return false;
                    }
                    let a_index = 0;
                    while (current_node != undefined && current_node !== spire_main_node) {
                        current_node.sparyFlow = last_spray_flow * a_list[a_index];
                        current_node.segmentFlow = current_node.sparyFlow + current_node._children[0].segmentFlow;
                        a_index += 1;
                        current_node = current_node.parent;
                    }
                    //反算当前节点压力;
                    if (spire_main_node._children.length == 1) {
                        spire_main_node.sparyFlow = sub_child.sparyFlow;
                        spire_main_node.segmentFlow = sub_child.segmentFlow;
                        spire_main_node.isPositive = true;
                    }
                    sub_child.end_pressure = spire_main_node.startPressure;
                    sub_child.isPositive = true;
                    console.log(JSON.stringify(sub_child));
                    pushNodeJson(sub_child);
                    while (sub_child._children.length > 0) {
                        let child = sub_child._children[0];
                        child.isPositive = true;
                        child.end_pressure = sub_child.startPressure;
                        console.log(JSON.stringify(child));
                        pushNodeJson(sub_child);
                        sub_child = child;
                    }
                }
            }
            if (spire_main_node.parent !== undefined) {
                if (spire_main_node._children.length > 1) {
                    if (spire_main_node.segmentFlow == 0) {
                        for (let child of spire_main_node._children) {
                            spire_main_node.segmentFlow += child.segmentFlow;
                        }
                        spire_main_node.sparyFlow = spire_main_node.segmentFlow;
                    }
                }
                console.log(JSON.stringify(spire_main_node));
                pushNodeJson(spire_main_node);
                if (spire_main_node.end_pressure === 0) {
                    spire_main_node.parent.start_pressure = spire_main_node.endPressure;
                    calcrecursion(spire_main_node.parent);
                }
            }
        };
        calcrecursion(main_node);
        seg_total.output_json = output_json;
        this._output_json = JSON.stringify(seg_total);
        return true;
    }
    findWaterFloorPoint(geo_point) {
        //获取离positon最远的一个点,使用的水流指示器;
        let shapes = geo_point.subData().getShapes(null);
        let max_disance = -1;
        let max_point = null;
        for (let shape of shapes) {
            if (shape instanceof segment_1.RLine) {
                let start_distance = geo_point
                    .subData()
                    .position.getDistanceTo(shape.getStartPoint());
                let end_distance = geo_point
                    .subData()
                    .position.getDistanceTo(shape.getEndPoint());
                let current_distance = start_distance;
                let current_point = shape.getStartPoint();
                if (end_distance > start_distance) {
                    current_distance = end_distance;
                    current_point = shape.getEndPoint();
                }
                if (max_disance < current_distance) {
                    max_disance = current_distance;
                    max_point = current_point;
                }
            }
        }
        return max_point;
    }
    findChildPoints(node, layers) {
        let point = new ltpoint_1.LTPoint(node._point.x, node._point.y);
        let parent_node_point = null;
        if (node._parent != null) {
            parent_node_point = new ltpoint_1.LTPoint(node._parent._point.x, node._parent._point.y);
        }
        function callback(feature) {
            let geo = feature.getGeometry();
            if (!(geo instanceof ltentity_1.LTLine)) {
                return false;
            }
            if (geo.subData().getStartPoint().equalsFuzzy(point, 1e-4) || geo.subData().getEndPoint().equalsFuzzy(point, 1e-4)) {
                return true;
            }
            return false;
        }
        let query_box = ltpoint_1.RBox.fromCenter(point, 10);
        let result_point = [];
        for (let sub_layer of layers) {
            let feas = sub_layer.getFeatures(query_box, callback);
            for (let sub_fea of feas) {
                let sub_line = sub_fea.getGeometry();
                if (sub_line.subData().getStartPoint().equalsFuzzy(point, 1e-4)) {
                    if (parent_node_point != null && parent_node_point.equalsFuzzy(sub_line.subData().getEndPoint(), 1e-4)) {
                        continue;
                    }
                    if (ltutils_1.LTUtils.containsByPoint(this._select_polyline_area.subData().vertices, sub_line.subData().getEndPoint())) {
                        result_point.push(sub_line.subData().getEndPoint());
                    }
                }
                else {
                    if (parent_node_point != null && parent_node_point.equalsFuzzy(sub_line.subData().getStartPoint(), 1e-4)) {
                        continue;
                    }
                    if (ltutils_1.LTUtils.containsByPoint(this._select_polyline_area.subData().vertices, sub_line.subData().getStartPoint())) {
                        result_point.push(sub_line.subData().getStartPoint());
                    }
                }
            }
        }
        return result_point;
    }
    buildTree(root_point) {
        //计算喷淋主管和喷淋支管这两个图层;
        let layer1 = this._map.getLayerByName(sprinklerutils_1.MAINPIPE_LAYER);
        let layer2 = this._map.getLayerByName(sprinklerutils_1.BRANCHPIPE_LAYER);
        if (layer1 == null || layer2 == null) {
            return null;
        }
        let layers = [layer1, layer2];
        let root_node = new SpireNode(this._map, root_point, pipeNode_1.PipeNodeType.Main);
        this.addChildNode(root_node, layers);
        return root_node;
    }
    //判断当前点是否有喷头
    findSprink(point, layer) {
        function callback(fea) {
            let geo = fea.getGeometry();
            if (!(geo instanceof ltentity_1.LTEntityPoint)) {
                return false;
            }
            let block_name = geo.subData().blockName;
            if (block_name == null) {
                return false;
            }
            if (config_1.SprinklerSettingMethod.indexOf(block_name) >= 0 || block_name === sprinklerutils_1.BLOCK_DEADLINE) {
                return true;
            }
            return false;
        }
        let box = ltpoint_1.RBox.fromCenter(point, 10);
        return layer.getFeature(box, callback);
    }
    addChildNode(parent_node, layers) {
        let child_points = this.findChildPoints(parent_node, layers);
        if (child_points.length <= 1) {
            //判断是否有喷头;
            let sub_point = new ltpoint_1.LTPoint(parent_node._point.x, parent_node._point.y);
            let spr_fea = this.findSprink(sub_point, layers[1]);
            if (spr_fea !== null) {
                let sub_geo = spr_fea.getGeometry();
                if (config_1.SprinklerSettingMethod.indexOf(sub_geo.subData().blockName) >= 0) {
                    parent_node._type = pipeNode_1.PipeNodeType.Child;
                }
                else {
                    parent_node._type = pipeNode_1.PipeNodeType.Valve;
                }
            }
        }
        for (let sub_point of child_points) {
            let sub_node = new SpireNode(this._map, sub_point, pipeNode_1.PipeNodeType.Main);
            parent_node.addChildNode(sub_node);
            this.addChildNode(sub_node, layers);
        }
    }
    //遍历搜索某个节点
    traverseSearchPoint(node, point) {
        if (node._point.equals2D(point)) {
            return node;
        }
        for (let child_node of node._children) {
            let result = this.traverseSearchPoint(child_node, point);
            if (result != null) {
                return result;
            }
        }
        return null;
    }
    //查找范围内之外的主管道起点, 即水流方向的起点
    findMainPipeStartPoint() {
        //获取保护范围,应该有用户指定,是一个闭合多边形
        if (this._map === null || this._select_polyline_area == null) {
            return null;
        }
        // 获取指定名称的图层
        let branch_layer = this._map.getLayerByName(sprinklerutils_1.BRANCHPIPE_LAYER);
        let main_pipe_layer = this._map.getLayerByName(sprinklerutils_1.MAINPIPE_LAYER);
        // 检查图层是否存在
        if (branch_layer == null || main_pipe_layer == null) {
            return null;
        }
        const find_pipe_callback = (feature) => {
            let geo = feature.getGeometry();
            if (geo instanceof ltentity_1.LTLine || geo instanceof ltentity_1.LTPolyline) {
                //获取多边形内部的图形和与其相交的图形;
                if (this._select_polyline_area.intersectsWith(geo)) {
                    return true;
                }
            }
            return false;
        };
        let result_features = main_pipe_layer.getFeatures(this._select_polyline_area.getBoundingBox(), find_pipe_callback);
        if (result_features.length == 0) {
            this._map.printMessage("未找到主管道");
            return null;
        }
        let min_distance = null;
        let target_point = null;
        let result_points = new Set();
        for (let feat_item of result_features) {
            let feat_geo = feat_item.getGeometry();
            if (feat_geo instanceof ltentity_1.LTLine) {
                let start_point = feat_geo.subData().getStartPoint();
                let end_point = feat_geo.subData().getEndPoint();
                result_points.add(start_point);
                result_points.add(end_point);
            }
        }
        for (let point of result_points) {
            if (ltutils_1.LTUtils.containsByPoint(this._select_polyline_area.subData().vertices, point)) {
                continue;
            }
            //点到保护区域的距离;
            let dis = this._select_polyline_area.subData().getDistanceTo(point);
            if (min_distance == null || dis < min_distance) {
                min_distance = dis;
                target_point = point;
            }
        }
        return target_point;
    }
}
function* newCalcSpire(map, param_map) {
    //选择的一个闭合区域;
    function drawCallback(fea) {
        let result_geometry = fea.getGeometry();
        if (!(result_geometry instanceof ltentity_1.LTPolyline)) {
            return false;
        }
        return result_geometry.subData().isClosed();
    }
    let select_param_map = {
        command_tip: "请选择一个喷淋的闭合区域:",
        callback: drawCallback,
    };
    commandfactory_1.CommandFactory.getInstance().execYieldCommand("select", map, select_param_map);
    let input_select_features = yield;
    let features = input_select_features.value;
    if (features == null || features.length == 0) {
        return { value: null, done: commandfactory_1.CommandStatus.eDone };
    }
    let result_geometry = features[0].getGeometry();
    if (result_geometry == null) {
        return { value: null, done: commandfactory_1.CommandStatus.eDone };
    }
    let mm = new NewSprink(map, result_geometry, 80, 8, 160);
    if (mm.ConstructingTree()) {
        window.downDesgFile(mm._output_json);
    }
    return { value: null, done: commandfactory_1.CommandStatus.eDone };
}
exports.newCalcSpire = newCalcSpire;
